import { useFormat } from 'vivat';

const toDecimalFormat = (string: any) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default {
  types: {
    // _primaryControls: {
    //   width: '3rem',
    // },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    delivered: {
      name: 'การส่ง',
      width: '3.5rem',
      class: 'text-center',
    },
    code: {
      name: 'รหัสสินค้า',
      width: '8rem',
      class: 'text-center',
    },
    name: {
      name: 'ชื่อสินค้า',
      width: '1.5fr',
    },
    unitsPerCount: {
      name: 'จำนวน (บรรจุ)',
      width: '4rem',
      filter: (val: string, row: any) => toDecimalFormat(row.item.deliveryFee / row.item.count),
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
    },
    count: {
      name: 'จำนวน (หีบห่อ)',
      width: '4rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
    },
    weight: {
      name: 'น้ำหนัก (กก.)',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      width: '6rem',
      filter: (val: string) => toDecimalFormat(val),
    },
    deliveryFeeRate: {
      name: 'ค่าจัดส่ง/หน่วย (บาท)',
      width: '8rem',
      filter: (val: string, row: any) => toDecimalFormat(row.item.deliveryFee / row.item.count),
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
    },
    deliveryFee: {
      name: 'ค่าจัดส่ง (บาท)',
      width: '5rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => useFormat.number(val).currency(),
    },
    _remarksControls: {
      name: 'หมายเหตุ',
      width: '12rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
    },
    // width: {
    //   name: 'กว้าง',
    //   width: '6rem',
    // },
    // length: {
    //   name: 'ยาว',
    //   width: '3rem',
    // },
    // height: {
    //   name: 'สูง',
    //   width: '3rem',
    // },
    // packageUnit: {
    //   name: 'หน่วยหีบห่อ',
    //   width: '6rem',
    //   class: 'text-right',
    // },
  },
};
